var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRiamsLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-25 -25)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(25 25)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#009DE0",
    width: 40,
    height: 40,
    rx: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.916 20.721l5.146 4.043a8.017 8.017 0 01-5.146-4.043zM21 14h-6.5a2.5 2.5 0 110-5H21a8 8 0 014.337 14.723L20.6 20h.4l.176-.005a3 3 0 000-5.99L21 14z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8 20h2.417a4 4 0 012.47.855l9.925 7.797A1.314 1.314 0 0127.8 31h-2.417a4 4 0 01-2.47-.855l-9.925-7.797A1.314 1.314 0 0113.8 20z",
    fill: "#FFF"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiamsLogo);
export default __webpack_public_path__ + "static/media/RiamsLogo.4424ae257b6d7151867a7f78c554213b.svg";
export { ForwardRef as ReactComponent };